var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"upyield-publisher min-h-screen bg-gray-100"},[(_vm.auth.isLoaded)?_c('router-view'):_c('section',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.auth.isLoaded),expression:"!auth.isLoaded"}],staticClass:"app-content-spinner min-h-screen"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }